import { Stack } from 'expo-router';

const SettingsLayout = () => {
  return (
    <Stack
      screenOptions={{
        headerShadowVisible: false,
        headerBackVisible: false
      }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="preferences" />
      <Stack.Screen name="editRange" />
      <Stack.Screen name="editName" />
      <Stack.Screen name="changePassword" />
      <Stack.Screen name="favorites" />
      <Stack.Screen name="faq" />
      <Stack.Screen name="transactions" />
      <Stack.Screen name="subscriptions" />
      <Stack.Screen name="giftsList" />
    </Stack>
  );
};

export default SettingsLayout;
